import { component } from 'picoapp';
var hoverintent = require('hoverintent');
import { gsap } from 'gsap/all';
import { position } from 'dom-helpers';

function outsideClick(event, notelem) {
  var clickedOut = true,
    i,
    len = notelem.length;
  for (i = 0; i < len; i++) {
    if (notelem[i] && (event.target == notelem[i] || notelem[i].contains(event.target))) {
      clickedOut = false;
    }
  }
  if (clickedOut) return true;
  else return false;
}

class MenuItem {
  constructor(el, parent) {
    this.el = el;
    this.parent = parent;
    this.target = el.dataset.target;
    this.dropdown = document.querySelector(`.Nav__submenu[data-identifier='${this.target}']`);
    this.identifier = this.target;
    this.isOpen = false;
    this.init()
    this.bindEvents();
  }

  positionArrowDeco() {
    if (this.dropdown) {
      const deco = this.dropdown.querySelector('.deco');
      const dropdownWidth = gsap.getProperty(this.dropdown.parentNode, "width");
      const parentPosition = this.el.getBoundingClientRect().left;
      const parentWidth = gsap.getProperty(this.el, "width");
      const decoPosition = parentPosition + (parentWidth / 2) - ((window.innerWidth - dropdownWidth) / 2) + "px";
      deco.style.left = decoPosition
    }
  }

  init() {
    this.tl = gsap.timeline({
      paused: true,
      onComplete: () => {

      },
      onReverseComplete: () => {

      }
    })

    this.tl.fromTo(this.dropdown, { display: 'none', opacity: 0, y: 50 }, { display: 'block', opacity: 1, y: 0, duration: 0.2 })

    this.positionArrowDeco()
  }

  bindEvents() {
    window.addEventListener('resize', () => {
      this.positionArrowDeco()
    })

    this.parent.ctx.on('toggleMenuItem', (state) => {
      const { type, identifier } = state;
      if (!type | (type != 'menu-item')) {
        return;
      }

      if (identifier == this.identifier) {
        this.open();
      } else {
        this.close();
      }
    });

    // While hovering the menu item
    hoverintent(
      this.el,
      () => {
        this.parent.ctx.emit('toggleMenuItem', { type: 'menu-item', identifier: this.target });
      },
      () => { },
      {
        timeout: 300,
        interval: 50,
      }
    );

    // When leaving the menu dropdown
    hoverintent(
      this.dropdown,
      () => {
        // if entering back onto the menu clear the previously set
        // timeout for closing the menu
        window.clearTimeout(this.menuTimeout);
      },
      () => {
        // this.tl.set
        this.menuTimeout = window.setTimeout(() => {
          this.close();
          // this.parent.ctx.emit('closeMainMenu');
        }, 350);
      },
      {
        timeout: 100,
      }
    );

    this.el.addEventListener('keyup', (e) => {
      if (e.keyCode == 13) {
        this.parent.ctx.emit('toggleMenuItem', { type: 'menu-item', identifier: this.target });
        setTimeout(() => {
          this.dropdown?.querySelector('a').focus();
        }, 200)
      }
    })

    this.dropdown?.addEventListener('focusout', (e) => {
      if (!this.dropdown.contains(e.relatedTarget)) {
        this.close();
        this.el.querySelector('a').focus();
      }
    })

    // when clicking outside the menu close it
    document.addEventListener('click', (e) => {
      if (outsideClick(e, [this.el, this.dropdown])) {
        this.close();
        // this.parent.ctx.emit('closeMainMenu');
      }
    });
  }
  open() {
    this.tl.play()
    this.isOpen = true;
  }
  close() {
    this.tl.timeScale(2).reverse()
    this.isOpen = false;
  }
}

class MegaMenu {
  constructor(el, ctx) {
    this.mainOptions = el.querySelectorAll('.Nav__item--main.level-1');
    this.ctx = ctx;
    this.init();
  }
  init() {
    this.mainOptions.forEach((el) => {
      new MenuItem(el, this);
    });
  }
}

export default component((node, ctx) => {
  new MegaMenu(node, ctx);
});
